<template>
  <v-dialog v-model="dialog" width="500" style="padding: 0px 8px;">
    <template v-slot:activator="{ on }">
      <v-btn
        :color="!!buttonColor ? buttonColor : primary"
        :disabled="disabled"
        :loading="loading"
        dark
        v-on="on"
      >
        {{ buttonText }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline mdred lighten-1 white--text" primary-title>
        {{ messageTitle }}
      </v-card-title>
      <v-card-text>
        {{ messageBody }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined @click="dialog = false">
          {{ $t("app.buttons.cancel") }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn dark color="primary" @click="confirm()">
          {{ $t("app.buttons.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: function() {
        return this.$t("app.buttons.confirm");
      }
    },
    buttonColor: {
      type: String,
      default: "primary"
    },
    messageTitle: {
      type: String,
      required: true
    },
    messageBody: {
      type: String,
      default: ""
    },
    disabled: Boolean,
    loading: Boolean
  },
  data: () => ({
    dialog: false
  }),

  methods: {
    confirm() {
      this.$emit("confirm");
      this.dialog = false;
    }
  }
};
</script>
